import {Color} from "three";
import * as THREE from "three";

function generateTexture() {

    const canvas = document.createElement('canvas');
    canvas.width = 2;
    canvas.height = 2;

    const context = canvas.getContext('2d');
    context.fillStyle = 'white';
    context.fillRect(0, 1, 2, 1);

    return canvas;

}

//const texture = new THREE.CanvasTexture( generateTexture() );

export const MATERIAL_PROPS_DB = [


    {
        materialName: "GlassMat",
        glass: true,
        glassMatFunc: (envMap) => {
            return new THREE.MeshPhysicalMaterial({
                name: `GlassMat-MPM`,
                color: new Color( 0.29119921875000004, 0.5729965745192305, 0.8 ),
                emissive: new THREE.Color(0.20969663085937498, 0.21999999999999997, 0.21999999999999997),
                metalness: .01,
                roughness: 0,
                // alphaMap: texture,
                // alphaTest: 0.5,
                //envMap: envMap, //this.backgroundMap,
                envMapIntensity: 0.5,
                depthWrite: false,
                transmission: 1, // use material.transmission for glass materials
                opacity: 0.4, // set material.opacity to 1 when material.transmission is non-zero
                transparent: true,
                //ior: 1.5,
                //specularIntensity: 1,
                //specularColor: 0xffffff,
                //side: THREE.DoubleSide,
                //alphaMap: texture,
                toneMapped: true,
            });
        },
    },
    {
        materialName: "TableTopGlassMat",
        glass: true,
        glassMatFunc: (envMap) => {
            return new THREE.MeshPhysicalMaterial({
                name: `TableTopGlassMat-MPM`,
                color: new THREE.Color(0x000000),
                emissive: new THREE.Color(0, 0, 0),
                metalness: .01,
                roughness: 0.13,
                // alphaMap: texture,
                // alphaTest: 0.5,
                //envMap: envMap, //this.backgroundMap,
                envMapIntensity: 2.88,
                //depthWrite: false,
                transmission: 1, // use material.transmission for glass materials
                opacity: .34, // set material.opacity to 1 when material.transmission is non-zero
                transparent: true,
                //ior: 1.5,
                //specularIntensity: 1,
                //specularColor: 0xffffff,
                //  side: THREE.DoubleSide,
                //alphaMap: texture,
                toneMapped: true,
            });
        },
    },


    {
        materialName: "FloorMat",
        aOIntensity: 1.0117089080959614,
        envMapIntensity: 1.8,
        roughness: 0.42,
        // toneMapped:'N',

    },


    /* {
         materialName: "W01EP01G001_mat",
         convertToBasicMaterial: 'Y',
         toneMapped:'N',

     },*/








    {
        materialName: "ceiling_southW_white_mat",
        // convertToBasicMaterial: 'Y',
          aOIntensity:0.53,
          envMapIntensity:0.735,
          toneMapped:'N',

       /* aOIntensity: 0.789730158678323,
        envMapIntensity: 1.5,
        toneMapped:'N'*/


    },

    {
        materialName: "BalconyMat",
        aOIntensity: 0.66,
        envMapIntensity: 1,
        toneMapped: 'N',

    },


    {
        materialName: "CoffeTable01Mat",
        aOIntensity: 0.8197745630296611,

    },


    {
        materialName: "Floor_mat",
          aOIntensity: 0.4044974642165523,
          envMapIntensity: 0.954,
          toneMapped: 'N',
          roughness: 0.3798121422934505,
          metalness: 0.3265923427999546,

       /* aOIntensity:0.757627434139842,
        envMapIntensity:6.93633599702172,
        roughness:0.32,
        metalness:0.33,*/

    },


    {
        materialName: "All_steel_mat",
        aOIntensity: 0.5327307126544983,
        envMapIntensity: 4.52137797832651,
    },

    {
        materialName: "CeilingMat",
       aOIntensity: 0.38, //for baked
       //   aOIntensity: 0.57,
        toneMapped: 'N',
        envMapIntensity: 1.0,
        //convertToBasicMaterial: 'Y',
    },

    {
        materialName: "semiDarkGlassMat",
        toneMapped: 'N',
        convertToBasicMaterial: 'Y',
    },


    {
        materialName: "chairTableMat",
        aOIntensity: 0.6604582314388885,
    },

    {
        materialName: "StairsFloorMat",
        aOIntensity: 0.7,
        toneMapped: 'N',
    },

    /* {
         materialName:"Floor_outside_mat",
         aOIntensity:0.7243219908310835,

         envMapIntensity:1.01951517165448,

         roughness:0.3691681823947513,
         metalness:0.48625174128044224,

     },*/

    {
        materialName: "TextMat",
        emmisiveColor: new THREE.Color(0xFF0000),
        emmissiveIntensity: 2.0,
        toneMapped: 'N',
    },
    {
        materialName: "NewsDesk3dTextMat",
        emmisiveColor: new THREE.Color("rgb(171, 21, 165)"),
        emmissiveIntensity: 0.6,
        color: new THREE.Color(0xFFFFFF),
        toneMapped: 'N',
    },

    {
        materialName:"NewsDeskMat",
        aOIntensity:0.8724803553126067,
        envMapIntensity:3.18372053296891,
        metalness:0.49854800136658695,



    },

    {
        materialName:"panelStealMat",
        aOIntensity:1,
        envMapIntensity:1.3470276733857192,
        roughness:0.17056713358387426,


    },


    {
        materialName:"WallNewsRoomMat",
        aOIntensity:0.789730158678323,
        envMapIntensity:7,
        toneMapped:'N',
        // roughness:0.7281346088144858,

    },

    {
        materialName:"Office_Chair_mat",
        aOIntensity:1,
        envMapIntensity:1.576614280833618,
        toneMapped:'N',

    },


    {
        materialName: "TableLampTop",
        emmisiveColor: new THREE.Color(0xFFFFFF),
        emmissiveIntensity: 5,
        toneMapped: 'N',
    },
    {
        materialName: "ceilingLightMat2",
        aOIntensity: 0.6285263517427909,
    },

    {
        materialName: "ECCB_UV_V01",
        toneMapped: 'N',
    },
    {
        materialName: "ECCB_UV_V02",
        toneMapped: 'N',
    },
    {
        materialName: "ECCB_UV_V03",
        toneMapped: 'N',
    },

    {
        materialName: "ECCB_UV_V04",
        toneMapped: 'N',
    },

    {
        materialName: "ECCB_UV_V05",
        toneMapped: 'N',
    },

    {
        materialName: "ECCB_UV_V06",
        toneMapped: 'N',
    },

    {
        materialName: "ECCB_UV_V07",
        toneMapped: 'N',
    },
    {
        materialName: "ECCB_UV_V08",
        toneMapped: 'N',
    },
    {
        materialName: "ECCB_UV_V09",
        toneMapped: 'N',
    },

    {
        materialName: "ECCB_UV_V09_B",
        toneMapped: 'N',
    },

    {
        materialName: "ECCB_UV_V10",
        toneMapped: 'N',
    },
    {
        materialName: "ECCB_UV_V11",
        toneMapped: 'N',
    },

    {
        materialName: "ECCB_UV_V14_01",
        toneMapped: 'N',
    },
    {
        materialName: "ECCB_UV_V15_01",
        toneMapped: 'N',
    },

    {
        materialName: "ECCB_UV_V16_01",
        toneMapped: 'N',
    },
    {
        materialName: "ECCB_UV_V17_01",
        toneMapped: 'N',
    },
    {
        materialName: "ECCB_UV_V18_01_V01",
        toneMapped: 'N',
    },
    {
        materialName: "ECCB_UV_V19_01_V01",
        toneMapped: 'N',
    },
    {
        materialName: "ECCB_UV_V20_01",
        toneMapped: 'N',
    },
    {
        materialName: "ECCB_UV_V21_01",
        toneMapped: 'N',
    },
    {
        materialName: "ECCB_UV_V22_01",
        toneMapped: 'N',
    },
    {
        materialName: "ECCB_UV_V23_01",
        toneMapped: 'N',
    },
    {
        materialName: "CiniplexNowShowingMat",
        toneMapped: 'N',
    },
    {
        materialName: "HdrBackMat",
        toneMapped: 'N',
    },
    {
        materialName: "ECCB_UV_V03_commin_soon",
        toneMapped: 'N',
        convertToBasicMaterial: 'Y',
    },

    {
        materialName: "Wall_UVT_02_1K",
        // aOIntensity: 0.3,
        toneMapped: 'N',
        // envMapIntensity: 0.8,
        convertToBasicMaterial: 'Y',
    },

    {
        materialName: "Wall_UVT_01_1K",
        // aOIntensity: 0.3,
        toneMapped: 'N',
        // envMapIntensity: 0.8,
        convertToBasicMaterial: 'Y',
    },
    {
        materialName: "Wall_UVT_05_1K",
        // aOIntensity: 0.3,
        toneMapped: 'N',
        // envMapIntensity: 0.8,
        convertToBasicMaterial: 'Y',
    },
    {
        materialName: "Wall_UVT_1K_07_1",
        // aOIntensity: 0.3,
        toneMapped: 'N',
        // envMapIntensity: 0.8,
        convertToBasicMaterial: 'Y',
    },
    {
        materialName: "Wall_UVT_1K_08",
        // aOIntensity: 0.3,
        toneMapped: 'N',
        // envMapIntensity: 0.8,
        convertToBasicMaterial: 'Y',
    },
    {
        materialName: "LOGO_V01",
        // aOIntensity: 0.3,
        toneMapped: 'N',
        // envMapIntensity: 0.8,
        convertToBasicMaterial: 'Y',
    },

    {
        materialName:"SculptureBaseNat",
        aOIntensity:0.89,
        envMapIntensity:7,
        toneMapped: 'N',

    },

    {
        materialName:"SirArthur8KMat",
        aOIntensity:1.4959900985249024,
        envMapIntensity:7,
        roughness:0.2846452025850949,

    },

    {
        materialName:"BenchMat",
        aOIntensity:0.7255247096013612,
        envMapIntensity:7,
    },

    {
        materialName: "VideoCameraBulkyMat",
        envMapIntensity: 4.4,
        toneMapped: 'Y',

    },

    {
        materialName:"Earphone2Mat",
        aOIntensity:1.0144492304476889,
        envMapIntensity:5.13858342286679,
        // roughness:0.45585973345699293,
        toneMapped:'N',

    },

    {
        materialName:"KioskMat",
        aOIntensity:1.1107574040631316,
        envMapIntensity:5.288396137379701,
        roughness:0.63,
        metalness:0.4451588252774993,

    },
    /*
[
{
 materialName:"CiniplexNowShowingMat",
aOIntensity:1,
emmisiveColor:undefined,
emmissiveIntensity:undefined,
envMapIntensity:undefined,
lightMapIntensity:1,
roughness:undefined,
metalness:undefined,
toneMapped:false,
color:
 new Color( 1, 1, 1 ),
 },

 ]

     */


]
